/* eslint-disable camelcase */
import axios from 'axios';
import {
  MENU_PREVIEW_ENDPOINT,
  OPTION_ENDPOINT,
  POINT_OF_SALE_ENDPOINT,
  PROFILE_COMPLETION_ENDPOINT,
  TOKEN_REFRESH_ENDPOINT,
  GROUP_TYPES_ENDPOINT,
  MODEL_LANGUAGES, MENU_GRID_PREVIEW_ENDPOINT,
  MENU_PREVIEW_INITIAL_RECOMMENDATION_STRUCTURE_ENDPOINT,
  MENU_BANNER_SHOP_STRUCTURE_ENDPOINT
} from './constants';

export const profileCompletionListRequest = () => axios.get(PROFILE_COMPLETION_ENDPOINT());

export const refreshTokenRequest = async (refreshToken) => {
  const { data } = await axios.post(TOKEN_REFRESH_ENDPOINT(), { refresh: refreshToken });
  return data.access;
};

export const pointOfSaleListRequest = () => axios.get(POINT_OF_SALE_ENDPOINT(), { params: { page_size: 0 } });

export const menuPreviewCacheRequest = (menuGuid, zoneGuid, serviceGuid, year, month, day) => axios.get(MENU_PREVIEW_ENDPOINT(menuGuid, zoneGuid, serviceGuid, year, month, day));

export const menuPreviewInitialRecommendationRequest = (menuGuid) => axios.get(MENU_PREVIEW_INITIAL_RECOMMENDATION_STRUCTURE_ENDPOINT(menuGuid));

export const menuPreviewBannerShopStructureRequest = (menuGuid) => axios.get(MENU_BANNER_SHOP_STRUCTURE_ENDPOINT(menuGuid));

export const menuGridPreviewCacheRequest = (menuGuid, zoneGuid, serviceGuid, year, month, day) => axios.get(MENU_GRID_PREVIEW_ENDPOINT(menuGuid, zoneGuid, serviceGuid, year, month, day));

export const optionsRequest = () => axios.get(OPTION_ENDPOINT());

export const groupTypeListRequest = () => axios.get(GROUP_TYPES_ENDPOINT());

export const modelLanguageRequest = () => axios.get(MODEL_LANGUAGES());
